// extracted by mini-css-extract-plugin
export default {"register-master-step1__select":"RegisterMasterModalStep_register-master-step1__select__KoWMp","footer-btn":"RegisterMasterModalStep_footer-btn__cCCbn"};